export default "__VITE_ASSET__BniSwD4K__"